import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { styled } from "@mui/material/styles";
import Paper from '@mui/material/Paper';
import { AddIcon, Minus, Trash } from "../../assets";
import { BSON } from 'bson';
import { TablePagination, tablePaginationClasses } from "@mui/base";
import FirstPageRoundedIcon from '@mui/icons-material/FirstPageRounded';
import LastPageRoundedIcon from '@mui/icons-material/LastPageRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { TableFooter } from "@mui/material";
import { AnimatedModal } from "..";
import { main_server } from "../../constants";

const colors = ['#55efc4', '#81ecec', '#74b9ff', '#a29bfe', '#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#ffeaa7', '#fab1a0', '#ff7675', '#fd79a8', '#fdcb6e', '#e17055', '#d63031'];

  export default function Variations(props) {
    const [selected, setSelected] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

    const [minimized, setMinimized] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - props.variations.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
    console.log(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  function formatMove(move) {
    if (move === undefined || move.san === undefined) return;
    if (!props.figure) return move.san;
    if (move.color === 'b') {
      return move.san.replace('N', '♘').replace('K', '♔').replace('R', '♖').replace('B', '♗').replace('Q', '♕');
    } else {
      return move.san.replace('N', '♞').replace('K', '♚').replace('R', '♜').replace('B', '♝').replace('Q', '♛');
    }
  }

   const [open, setOpen] = useState([]);

  function Row(props1: { row, dark, indx }) {
      const { row, dark, indx } = props1;
  
      return (
  <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset', background: props.dark ? '#2c3e50' : 'white' }}}>
          <TableCell>
            <IconButton
             sx={{color: props.dark ? 'white' : 'black'}}
              aria-label="expand row"
              size="small"
              onClick={() => {
                if (open.includes(row.id)) {
                    const tmp = open;
                    tmp.splice(tmp.indexOf(row.id), 1);
                    setOpen(tmp);
                } else {
                    setOpen([...open, row.id]);
                }
                setRefresh(refresh + 1);
              }}
            >
              {open.includes(row.id) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} component="th" scope="row">
            {row.id}
          </TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.variation}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.opening}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.lines}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{row.depth}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">{(BSON.calculateObjectSize(row) / 1000).toFixed(2) + ' KB'}</TableCell>
          <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right"><AnimatedModal body={<p className="w-full text-left text-gray-400">Are you sure you want to delete this variation ? This action is permanent.</p>} applyText="Delete" showButton={true} onClick={() => deleteVar(indx)} trigger={<Trash dark={props.dark} />} /></TableCell>
        </TableRow>
        <TableRow sx={{'& > *': {background: props.dark ? '#2c3e50' : 'white'}}}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open.includes(row.id)} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
              <div
      style={{
        zIndex: 20,
      }}
      className={`bg-[#292D32] rounded-lg w-[99%] h-[100%] mb-[5vh] flex flex-col items-center justify-between overflow-y-scroll`}
    >
              <div onMouseEnter={() => setSelected(0)} onMouseLeave={() => setSelected(null)} style={{borderBottomColor: 'white', borderBottomWidth: '0.01em', maxWidth: props.width < 768 ? '100%' : '785px'}} className="bg-gray-500 rounded pr-[55px] h-[55px] flex items-start justify-start flex-wrap overflow-y-scroll">
              <p style={{textDecoration: 'underline'}} className="text-white ml-1 mt-1">main line:</p>
              {row.main.map((move, index) => (
                <><p className="text-white mt-1 ml-2">{index % 2 === 0 && parseInt(index / 2 + 1) + '. '}</p><p className={`cursor-pointer hover:underline text-white mt-1 rounded`} >{formatMove(move)}</p></>
              ))}
              </div>
      <div style={{overflow: 'scroll', minHeight: 'calc(100% - 50px)'}} className={`flex flex-col items-start mt-[60px] justify-start w-full`}>
      
      {Array.from(Array(row.data.length + 1)).map((_, index) => {
          if (index === 0) {
            return <></>
          } else {
            return <div className="w-full flex items-center justify-between" style={{borderBottomColor: colors[index - 1], borderBottomWidth: '0.01em', }}><div onMouseEnter={() => setSelected(index)} onMouseLeave={() => setSelected(null)} className={`pr-[55px] w-full ${minimized.includes(index) && 'h-[30px] overflow-y-hidden'} min-h-[${(row.data[index - 1].lines ?? []).length * 28}px] flex items-start gap-1 justify-start flex-col`}>
              
              {row.data[index - 1].lines.map((move, indx) => (
                <>
                
                <div className="w-full flex items-start gap-2 justify-start flex-wrap">
                <p style={{color: colors[index - 1]}} className={`mt-1 ml-1`}>{String.fromCharCode(94 + indx + 3) + ') '}</p>
                {move.moves.map((mov, i) => (<><p style={{color: colors[index - 1]}} className="mt-1">{i % 2 === 0 && parseInt(i / 2 + 1) + '. '}</p><p onClick={() => {

        }} style={{color: colors[index - 1]}} className="cursor-pointer rounded hover:bg-gray-200 cursor-pointer text-white mt-1">{formatMove(mov[0])}
        </p>
        </>))}
        </div>
        {move.sub.length > 0 && move.sub.map((sub, j) => <div className={`w-full min-h-[${30 * move.sub.length / 10}px] flex items-start gap-2 justify-start flex-wrap`}>
                <p style={{color: colors[index - 1]}} className={`mt-1 ml-1`}>{String.fromCharCode(94 + indx + 3) + (j + 1) + ') '}</p>
                {sub.moves.map((mov, i) => (<>{sub.brc.map((vv, brcI) => {
                  if (vv.depth === i) return <><p className="mt-1"  style={{color: colors[index - 1]}}>{'('}</p>{vv.moves.map((b, brcMI) => <><p style={{color: colors[index - 1]}} className="mt-1">{(brcMI + sub.depth + vv.depth - 1) % 2 === 0 && parseInt((brcMI + sub.depth + vv.depth) / 2 + 1) + '. '}</p><p className="mt-1 rounded cursor-pointer hover:bg-gray-200" style={{color: colors[index - 1], textDecoration: (props.currentSub === j && props.currentBracet - 1 === brcI && (props.selectedMove === 0 ? (brcMI === vv.moves.length - 1) : (brcMI === props.selectedMove - 1))) ? 'underline' : 'none'}}>{formatMove(b[0])}</p></>)}<p className="mt-1"  style={{color: colors[index - 1]}}>{')'}</p></>
                })
                }<p style={{color: colors[index - 1]}} className="mt-1">{(i + sub.depth - 1) % 2 === 0 && parseInt((i + sub.depth) / 2 + 1) + '. '}</p><p style={{color: colors[index - 1], textDecoration: props.currentBracet === 0 ? ((props.currentSub === j && props.currentLine === indx) && (props.selectedMove === 0 ? (sub.moves.length - 1 === i ? 'underline' : 'none') : (i + sub.depth === props.selectedMove - 1 ? 'underline' : 'none'))) : 'none'}} className="cursor-pointer rounded hover:bg-gray-200 cursor-pointer text-white mt-1">{formatMove(mov[0])}
        </p>
        </>))}
        </div>)}
        
                
        </>
              ))}

              
              
              </div>
              <div className={`flex items-cetner justify-center`} onMouseEnter={() => setSelected(index)} onMouseLeave={() => setSelected(null)} >
              <Trash onClick={() => {

              }} line={true} color={colors[index - 1]} show={selected === index} />
              <div className="flex items-center justify-center " onClick={() => {

              }}>
                {minimized.includes(index) ? <AddIcon line={true} color={colors[index - 1]} show={selected === index} /> : <Minus color={colors[index - 1]} show={selected === index} />}
                </div>
                </div>
              </div>
          }
        })}
      </div>
      </div>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
      )
  }

  async function deleteVar(indx) {
    console.log(props.variations[indx]);
    const games = await fetch(main_server + "variation", {
      method: "DELETE",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + localStorage.getItem("chesscloud-token"),
      },
      body: JSON.stringify({variation: props.variations[indx]._id})
    });
    try { document.getElementById('modalClose').click(); } catch (e) {}
if (games.status === 200) {
const tmp = props.variations;
tmp.splice(indx, 1);
props.setVariations(tmp);
setRefresh(refresh + 1);
}
  }

    return (
      <TableContainer sx={{
        width: props.width < 768 ? '95%' : '85%', 
        marginLeft: props.width < 768 ? '2.5%' : '7.5%', 
        marginTop: '50px',
        overflowX: 'auto'
      }} component={Paper}>
        <Table aria-label="collapsible table" sx={{ minWidth: props.width < 768 ? 300 : 650 }}>
          <TableHead>
            <TableRow sx={{background: props.dark ? '#2c3e50' : 'white'}}>
              <TableCell />
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} >ID</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Name</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black', display: props.width < 768 ? 'none' : 'table-cell'}} align="right">Opening</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Lines</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black', display: props.width < 768 ? 'none' : 'table-cell'}} align="right">Depth</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black', display: props.width < 768 ? 'none' : 'table-cell'}} align="right">Size</TableCell>
              <TableCell sx={{color: props.dark ? 'white' : 'black'}} align="right">Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...props.variations].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <Row key={index + refresh} row={row} dark={props.dark} indx={index} />
            ))}
          </TableBody>
          <TableFooter>
          <tr>
            <CustomTablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={props.variations.length}
              rowsPerPage={rowsPerPage}
              page={page}
              slotProps={{
                select: {
                  'aria-label': 'rows per page',
                },
                actions: {
                  showFirstButton: true,
                  showLastButton: true,
                  slots: {
                    firstPageIcon: FirstPageRoundedIcon,
                    lastPageIcon: LastPageRoundedIcon,
                    nextPageIcon: ChevronRightRoundedIcon,
                    backPageIcon: ChevronLeftRoundedIcon,
                  },
                },
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </tr>
        </TableFooter>
        </Table>
      </TableContainer>
    );
}

const blue = {
  50: '#F0F7FF',
  200: '#A5D8FF',
  400: '#3399FF',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${tablePaginationClasses.spacer} {
    display: none;
  }

  & .${tablePaginationClasses.toolbar}  {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 4px 0;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${tablePaginationClasses.selectLabel} {
    margin: 0;
  }

  & .${tablePaginationClasses.select}{
    font-family: 'IBM Plex Sans', sans-serif;
    padding: 2px 0 2px 4px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    border-radius: 6px; 
    background-color: transparent;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    transition: all 100ms ease;

    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
    }

    &:focus {
      outline: 3px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      border-color: ${blue[400]};
    }
  }

  & .${tablePaginationClasses.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${tablePaginationClasses.actions} {
    display: flex;
    gap: 6px;
    border: transparent;
    text-align: center;
  }

  & .${tablePaginationClasses.actions} > button {
    display: flex;
    align-items: center;
    padding: 0;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    transition: all 120ms ease;

    > svg {
      font-size: 22px;
    }

    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
    }

    &:focus {
      outline: 3px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      border-color: ${blue[400]};
    }

    &:disabled {
      opacity: 0.3;

      &:hover {
        border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
        background-color: transparent;
      }
    }
  }
  `,
);
